import { useToast } from "../../ui";
import { useNextT } from "../../i18n";
import { isApiError, toApiError } from "../../data/errors";

type Toast = ReturnType<typeof useToast>;
type T = ReturnType<typeof useNextT>["t"];

/** True for the refusal staff get on the few things that stay blocked while viewing someone else's account. */
export const isViewingAsBlocked = (err: unknown): boolean => (isApiError(err) ? err : toApiError(err)).code === "VIEWING_AS_BLOCKED";

/** "This can't be done while viewing someone else's account." as the kit toast. Screens call `showBlockedIfSo`; this is exported for its own test. */
export const showBlocked = (toast: Toast, t: T): void => toast({ message: t("access.errors.viewing_as_blocked"), tone: "danger" });

/** Errors whose toast is already up: the shell shows it for every failed change, and a page that also calls `showBlockedIfSo` must not show it twice. */
const shown = new WeakSet<object>();

/** The default for any failed change: true (and the toast shown, once per failure) when this was the blocked refusal, false to let the caller go on. */
export const showBlockedIfSo = (err: unknown, toast: Toast, t: T): boolean => {
  if (!isViewingAsBlocked(err)) return false;
  if (typeof err === "object" && err !== null) {
    if (shown.has(err)) return true;
    shown.add(err);
  }
  showBlocked(toast, t);
  return true;
};
